export default "__VITE_ASSET__CkhYMX64__"